var map = {
	"./key-horizontal-ghost.svg": 140,
	"./key-horizontal-unlocked.svg": 141,
	"./key-horizontal.svg": 142,
	"./key-rotated-unlocked.svg": 143,
	"./key-rotated.svg": 144,
	"./key-vertical-ghost.svg": 145,
	"./key-vertical-unlocked.svg": 146,
	"./key-vertical.svg": 147,
	"./maze-1.svg": 148,
	"./maze-2.svg": 149,
	"./maze-3.svg": 150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;